import Network from '../../../../infrastructure/js/modules/network';

export function fetchLots() {
  return Network.get('lots');
}

export function fetchLotsGrid(query = {}) {
  return Network.post('lots/items?active=true', query);
}

export function fetchLotById(id) {
  return Network.get(`lots/${id}`);
}

export function updateLotStatus(lotId, data) {
  return Network.put(`lots/${lotId}/updateStatus`, data);
}

export function editLotsStatuses(data) {
  return Network.polling.post('lots/updateStatus', data);
}

export function checkCocCsvAutomation(lotId) {
  return Network.get(`lots/${lotId}/coc/automation/check`);
}

export function startCocCsvAutomation(lotId) {
  return Network.post(`lots/${lotId}/coc/automation/start`);
}
